/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerFindAllQueryResponse, ClientsControllerFindAllQueryParams, ClientsControllerFindAll401, ClientsControllerFindAll403 } from "../../models/clientsController/ClientsControllerFindAll";

function getClientsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/clients` as const }  
  return res
}

/**
 * @summary Get all clients
 * {@link /api/v1/clients}
 */
export async function clientsControllerFindAll(params?: ClientsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClientsControllerFindAllQueryResponse, ResponseErrorConfig<ClientsControllerFindAll401 | ClientsControllerFindAll403>, unknown>({ method : "GET", url : getClientsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}